export const flow = {
  HEB: {
    helpText: "לצפיה בסרטון הסבר על השימוש באפליקציה לחצו על הסרטון",
    creation: "הוספה",
    sidebar: {
      bank: "בנק",
      pension: "קופות ופנסיות",
      share: "שוק ההון",
      rsu: "RSU ואופציות",
      crypto: "קריפטו",
      debt: "הלוואות",
      realestate: 'נדל"ן',
      other: "אחר",
      recommendation: "אנחנו ממליצים להתחיל בהוספת הבנק!",
    },
    headers: {
      bankHeader: "בנקים",
      bank2Header: "הוספה ידנית",
      pensionHeader: "בתי השקעות",
      shareHeader: "ברוקרים",
      cryptoHeader: "ארנקי קריפטו",
      debtHeader: "הלוואות",
      realestateHeader: 'נדל"ן',
      otherHeader: "השקעות אלטרנטיביות",
    },
    miniHeaders: {
      bank2MiniHeader: "יש לבחור באחת מהאופציות הבאות:",
    },
    uniqueButtons: {
      exportToCsv: "יצוא לקובץ",
      masleka: "ייבא אוטומטית מכל הקופות הישראליות",
      riseUp: "להתחברות אוטומטית לבנקים בישראל באמצעות Rise up",
      openBanking: "לחיבור אוטומטי של הבנק/אשראי שלי",
      usBank: 'לחיבור בנק בארה"ב',
      horizon: "לרכישת מטבעות קריפטו בצורה מאובטחת ובטוחה",
      lendai: "למימון נדל״ן בארה״ב עבור ישראלים",
      importFromEtrade: "ייבוא מ-E*TRADE",
      importFromDocument: "ייבוא פוזיציות ממסמך",
      importStocksFromDocument: "ייבוא מניות ממסמך",
    },
    riseUpModal: {
      topText:
        "לקוחות יקרים, אנחנו עובדים על חיבור לבנקים בעזרת מאניטור אבל זה תהליך שלוקח זמן. לבינתיים דאגנו לכם לשיתוף פעולה",
      topTextBold: "שיצמיח את הגדילה הכלכלית שלכם!",
      topDisclaimer: "בשלב זה המידע יופיע רק ב- Rise UP.",
      values: "הטבות מיוחדות לנרשמים חדשים",
      value1:
        "בעזרת Rise Up ניתן לחבר את חשבונות הבנק וכרטיסי השאראי שלכם ולקבל הסתכלות קדימה",
      value1Bold: "לעבר חיסכון והתנהלות כלכלית נכונה",
      value2: "חודש התנסות בחינם ללא התחייבות",
      value3: "50% הנחה עבור חודשיים נוספים",
      linkText: "מעבר לאתר RISE UP",
      bottomDisclaimer: `לחיצה על הקישור תוביל אותך לאתר Rise up . אנו עובדים בשיתוף פעולה עם האתר על ידי הפניית לקוחות פוטנציאלים בכפוף להסדר מסחרי עם האתר, ובכלל זה תשלום עמלה. נבקש להבהיר כי אנו והאתר לא גובים ממך תשלום עמלה כלשהו בגין שיתוף הפעולה הנ"ל`,
    },
    openFinanceModal: {
      header: "אז איך החיבור עובד? ",
      topTextBold: "",
      topText: "באמצעות הבנקאות הפתוחה ניתן להתחבר לחשבונות שלכם בצורה מאובטחת ומהירה.\
      כל חיבור לחשבון בנק/ אשראי הוא נפרד, לאחר החיבור אנחנו נוסיף את המוצרים הקיימים באותו חשבון ונעדכן עבורכם את המידע בצורה שוטפת.",
      value1: "העברת המידע נעשית בסטנדרט האבטחה הגבוה ביותר.",
      value2: "מדיניות קריאה בלבד- מאניטור מאפשרת קריאה בלבד של הנתונים שלכם, לא תהיה אפשרות לבצע פעולות בחשבון.",
      value3: "התהליך מתבצע בעזרת חברת open finance שעוזרת לנו לחבר עבורכם את חשבונות הבנק, כל התהליך מתבצע בהתאם לרגולציות ולפיקוח של הרשות לניירות ערך.",
      linkText: "המשך",
    },
    quilttModal: {
      header: "חיבור בנק אמריקאי",
      topTextBold: "",
      topText:
        'ניתן לחבר את חשבונות הבנק שלכם בארה"ב ולראות אותם לצד שאר הנכסים. לאחר החיבור נוסיף את החשבונות ונעדכן עבורכם את היתרות באופן שוטף.',
      value1:
        "החיבור מתבצע באמצעות Quiltt ו-Finicity (חברה מקבוצת Mastercard) בסטנדרט האבטחה הגבוה ביותר.",
      value2:
        "מדיניות קריאה בלבד - מאניטור מאפשרת קריאה בלבד של הנתונים שלכם, לא תהיה אפשרות לבצע פעולות בחשבון.",
      value3:
        "פרטי ההתחברות לבנק מוזנים ישירות אצל Finicity בלבד ואינם נשמרים במאניטור.",
      linkText: "המשך",
    },
    horizonModal: {
      topText: "אפשר להשקיע בביטקוין ואתריום גם דרך הוראת קבע.",
      topTextBold: "כאשר קונים כל חודש בצורה שיטתית (הוראת קבע) אנו קונים גם כשהשוק יורד וגם כשהוא עולה ולא נותנים לרגש להשפיע עלינו.",
      values: "בין היתרונות של הוראת קבע דרך הוריזון ",
      value1: "סכומי מינימום נמוכים להפקדה החל מ-₪150",
      value2: "לא מעוניינים להמשיך? ניתן לבטל בכל עת",
      value3: "חברת הוריזון  היא בעלת רישיון למתן שירות פיננסי מורחב בפיקוח של רשות שוק ההון, ביטוח וחיסכון.",
      linkText: "מעבר לאתר הוריזון",
      bottomDisclaimer: `לחיצה על הקישור תוביל אותך לאתר הוריזון. אנו עובדים בשיתוף פעולה עם האתר על ידי הפניית לקוחות פוטנציאלים בכפוף להסדר מסחרי עם האתר, ובכלל זה תשלום עמלה. נבקש להבהיר כי אנו והאתר לא גובים ממך תשלום עמלה כלשהו בגין שיתוף הפעולה הנ"ל`,
    },
    lendaiModal: {
      topText: "דאגנו לכם לשיתוף פעולה עם חברת Lendai שמממנת נכסי נדל״ן בארה״ב עבור משקיעים זרים שבינהם ישראלים",
      topTextBold: "לא חייבים להיות בעלי אזרחות כדי לקנות ולהשקיע בנדל״ן בארה״ב.",
      values: "בשנים האחרונות משקיעים ישראלים מביעים יותר ויותר עניין בהשקעות נדל״ן בארה״ב, חלק מהסיבות לכך הן:",
      value1: "מציאת עסקאות נדל״ן שניתן להשיג עם הון עצמי נמוך ממה שנרדש בארץ",
      value2: "פוטנציאל לתשואה גבוהה יותר",
      value3: "שוק הנדל״ן בארה״ב הוא שוק מאוד ידידותי למשקיע",
      linkText: "מעבר לאתר LENDAI",
      bottomDisclaimer1: "בדיקה ראשונית ללא עלות, נדרש למלא פרטים, בקטגוריה של LOAN TYPE יש לבחור ב PRE APPROVAL.",
      bottomDisclaimer2: `לחיצה על הקישור תוביל אותך לאתר Lendai. אנו עובדים בשיתוף פעולה עם האתר על ידי הפניית לקוחות פוטנציאלים בכפוף להסדר מסחרי עם האתר, ובכלל זה תשלום עמלה. נבקש להבהיר כי אנו והאתר לא גובים ממך תשלום עמלה כלשהו בגין שיתוף הפעולה הנ"ל`
    },
    filter: {
      bankNotFound: "לא מצאתי את הבנק שלי",
      bank2NotFound: "לא מצאתי אופציה רלוונטית",
      pensionNotFound: "לא מצאתי את בית ההשקעות שלי",
      shareNotFound: "לא מצאתי את הברוקר שלי",
      cryptoNotFound: "לא מצאתי את הארנק שלי",
      debtNotFound: "לא מצאתי אופציה רלוונטית",
    },
    bottomRow: {
      preferManual: "מעדיפ/ה להוסיף ידנית",
    },
    save: "שמירה",
    notEditable: "אי אפשר לערוך את השדות בגלל שהם מחושבים על ידי ספק חיצוני.",
    openfinanceSuccessText:{
      header: "החיבור בוצע בהצלחה! ",
      details: "ניתן לראות את המוצרים שנוספו בטבלת הנכסים וההתחייבויות",
      button: "הבנתי, תודה!"
    },

    openfinancePartialSuccessText:{
      header: "החיבור בוצע בהצלחה! ",
      details: "חלק מהמוצרים עשויים להגיע כעבור מספר שעות, ניתן לראות את המוצרים שנוספו בטבלת הנכסים וההתחייבויות",
      button: "הבנתי, תודה!"
    },

    openfinanceFailText:{
      header: "החיבור נכשל ",
      details: "מצטערים קרתה בעיה במהלך תהליך החיבור, ניתן לנסות שוב",
      button: "נסה שנית"
    },

    openfinanceIncompleteText:{
      header: "הפעלת החיבור עדיין מתבצעת",
      details: "הבנק עדיין עשוי להשלים את החיבור ברקע. אם לאחר 30 שניות החיבור עדיין מופיע כלא פעיל, מומלץ להמתין מעט ולרענן את העמוד. בעת הרענון נבדוק שוב את סטטוס החיבור באופן אוטומטי.",
      button: "הבנתי"
    },
    openfinanceDeletedText:{
      header: "החיבור לבנק נמחק לבקשתך",
      details: "כל המוצרים שהגיעו מחיבור זה נמחקו, כדי להחזיר את החיבור ולהוסיף שוב את המוצרים יש ללחוץ על התחברות מחדש" ,
      button: "התחברות מחדש"
    },
    openfinanceInitializingConnection: "מאתחל חיבור לבנק",
    openfinanceInitializingConnectionCard: "מאתחל חיבור לאשראי",
    openfinanceFetchingProducts: "מייבא מוצרים מהבנק, שלב זה עשוי לקחת 30 שניות",
    openfinanceFetchingProductsCard: "מייבא מוצרים מהאשראי, שלב זה עשוי לקחת 30 שניות",
    
  },
  ENG: {
    helpText: "Click the video to watch an explanation on how to use the app",
    creation: "Add",
    sidebar: {
      bank: "Bank",
      pension: "Pensions & Funds",
      share: "Capital Markets",
      rsu: "RSU & Options",
      crypto: "Crypto",
      debt: "Loans",
      realestate: "Real Estate",
      other: "Other",
      recommendation: "We recommend starting by adding your bank!",
    },
    headers: {
      bankHeader: "Banks",
      bank2Header: "Manual entry",
      pensionHeader: "Investment houses",
      shareHeader: "Brokers",
      cryptoHeader: "Crypto wallets",
      debtHeader: "Loans",
      realestateHeader: "Real Estate",
      otherHeader: "Alternative investments",
    },
    miniHeaders: {
      bank2MiniHeader: "Please choose one of the following options:",
    },
    uniqueButtons: {
      exportToCsv: "Export to file",
      masleka: "Automatically import from all Israeli pension funds",
      riseUp: "Auto-connect to Israeli banks via Rise Up",
      openBanking: "Auto-connect my bank/credit card",
      usBank: "Connect a US bank",
      horizon: "Buy crypto safely and securely",
      lendai: "Finance US real estate for Israelis",
      importFromEtrade: "Import from E*TRADE",
      importFromDocument: "Import Positions from Document",
      importStocksFromDocument: "Import Stocks from Document",
    },
    riseUpModal: {
      topText: "Dear customers, we're working on connecting to banks via Moneytor but it takes time. In the meantime, we've arranged a partnership",
      topTextBold: "that will grow your financial wealth!",
      topDisclaimer: "At this stage, the data will only appear in Rise UP.",
      values: "Special benefits for new registrants",
      value1: "With Rise Up you can connect your bank accounts and credit cards and get a forward-looking view",
      value1Bold: "towards savings and proper financial management",
      value2: "Free trial month with no commitment",
      value3: "50% discount for two additional months",
      linkText: "Go to RISE UP website",
      bottomDisclaimer: "Clicking the link will take you to the Rise Up website. We work in partnership with the website by referring potential customers subject to a commercial arrangement, including commission payment. We clarify that neither we nor the website charge you any commission for this partnership.",
    },
    openFinanceModal: {
      header: "So how does the connection work?",
      topTextBold: "",
      topText: "Using Open Banking, you can connect to your accounts securely and quickly. Each bank/credit account connection is separate. After connecting, we'll add existing products and keep your data updated regularly.",
      value1: "Data transfer is done with the highest security standard.",
      value2: "Read-only policy - Moneytor only reads your data, no actions can be performed on your account.",
      value3: "The process is done with Open Finance, which helps us connect your bank accounts in compliance with Securities Authority regulations.",
      linkText: "Continue",
    },
    quilttModal: {
      header: "Connect an American bank",
      topTextBold: "",
      topText:
        "You can connect your US bank accounts and see them alongside the rest of your assets. After connecting, we'll add the accounts and keep your balances updated regularly.",
      value1:
        "The connection is made via Quiltt and Finicity (a Mastercard company) with the highest security standard.",
      value2:
        "Read-only policy - Moneytor only reads your data, no actions can be performed on your account.",
      value3:
        "Your bank credentials are entered directly with Finicity only and are never stored in Moneytor.",
      linkText: "Continue",
    },
    horizonModal: {
      topText: "You can invest in Bitcoin and Ethereum even via standing order.",
      topTextBold: "When you buy systematically every month (standing order), you buy both when the market goes down and up, not letting emotions influence you.",
      values: "Advantages of a standing order through Horizon",
      value1: "Low minimum deposit amounts starting from ₪150",
      value2: "Don't want to continue? Cancel anytime",
      value3: "Horizon holds an extended financial service license supervised by the Capital Markets Authority.",
      linkText: "Go to Horizon website",
      bottomDisclaimer: "Clicking the link will take you to the Horizon website. We work in partnership with the website by referring potential customers subject to a commercial arrangement, including commission payment.",
    },
    lendaiModal: {
      topText: "We've arranged a partnership with Lendai, which finances US real estate for foreign investors including Israelis",
      topTextBold: "You don't need to be a citizen to buy and invest in US real estate.",
      values: "In recent years, Israeli investors have shown growing interest in US real estate investments, for several reasons:",
      value1: "Finding real estate deals achievable with lower equity than required domestically",
      value2: "Potential for higher returns",
      value3: "The US real estate market is very investor-friendly",
      linkText: "Go to LENDAI website",
      bottomDisclaimer1: "Free initial check, details required. In the LOAN TYPE category, select PRE APPROVAL.",
      bottomDisclaimer2: "Clicking the link will take you to the Lendai website. We work in partnership with the website by referring potential customers subject to a commercial arrangement, including commission payment."
    },
    filter: {
      bankNotFound: "I can't find my bank",
      bank2NotFound: "I can't find a relevant option",
      pensionNotFound: "I can't find my investment house",
      shareNotFound: "I can't find my broker",
      cryptoNotFound: "I can't find my wallet",
      debtNotFound: "I can't find a relevant option",
    },
    bottomRow: {
      preferManual: "Prefer to add manually",
    },
    save: "Save",
    notEditable: "These fields cannot be edited because they are calculated by an external provider.",
    openfinanceSuccessText:{
      header: "Connection successful!",
      details: "You can see the added products in the assets and liabilities table",
      button: "Got it, thanks!"
    },
    openfinancePartialSuccessText:{
      header: "Connection successful!",
      details: "Some products may arrive within a few hours. You can see the added products in the assets and liabilities table",
      button: "Got it, thanks!"
    },
    openfinanceFailText:{
      header: "Connection failed",
      details: "Sorry, there was a problem during the connection process. You can try again",
      button: "Try again"
    },
    openfinanceIncompleteText:{
      header: "The connection is still being activated",
      details: "Your bank may still complete the connection in the background. If it is still shown as inactive after 30 seconds, wait a little and refresh the page. We will automatically check its status again when the page loads.",
      button: "Got it"
    },
    openfinanceDeletedText:{
      header: "Bank connection deleted at your request",
      details: "All products from this connection have been deleted. To restore the connection and add products again, click reconnect",
      button: "Reconnect"
    },
    openfinanceInitializingConnection: "Initializing bank connection",
    openfinanceInitializingConnectionCard: "Initializing credit card connection",
    openfinanceFetchingProducts: "Importing products from bank, this step may take 30 seconds",
    openfinanceFetchingProductsCard: "Importing products from credit card, this step may take 30 seconds",
  },
  RUS: {
    helpText: "Нажмите на видео, чтобы посмотреть инструкцию по использованию приложения",
    creation: "Добавить",
    sidebar: {
      bank: "Банк",
      pension: "Пенсии и фонды",
      share: "Фондовый рынок",
      rsu: "RSU и опционы",
      crypto: "Крипто",
      debt: "Кредиты",
      realestate: "Недвижимость",
      other: "Другое",
      recommendation: "Рекомендуем начать с добавления вашего банка!",
    },
    headers: {
      bankHeader: "Банки",
      bank2Header: "Ручной ввод",
      pensionHeader: "Инвестиционные компании",
      shareHeader: "Брокеры",
      cryptoHeader: "Криптокошельки",
      debtHeader: "Кредиты",
      realestateHeader: "Недвижимость",
      otherHeader: "Альтернативные инвестиции",
    },
    miniHeaders: {
      bank2MiniHeader: "Выберите один из следующих вариантов:",
    },
    uniqueButtons: {
      exportToCsv: "Экспорт в файл",
      masleka: "Автоматический импорт из всех израильских пенсионных фондов",
      riseUp: "Автоматическое подключение к израильским банкам через Rise Up",
      openBanking: "Автоматическое подключение моего банка/кредитной карты",
      usBank: "Подключить банк в США",
      horizon: "Безопасная покупка криптовалюты",
      lendai: "Финансирование недвижимости в США для израильтян",
      importFromEtrade: "Импорт из E*TRADE",
      importFromDocument: "Импорт позиций из документа",
      importStocksFromDocument: "Импорт акций из документа",
    },
    riseUpModal: {
      topText: "Уважаемые клиенты, мы работаем над подключением к банкам через Monitor, но это занимает время. Тем временем мы организовали партнёрство",
      topTextBold: "которое поможет вашему финансовому росту!",
      topDisclaimer: "На данном этапе данные будут отображаться только в Rise UP.",
      values: "Специальные привилегии для новых пользователей",
      value1: "С помощью Rise Up вы можете подключить свои банковские счета и кредитные карты и получить перспективный обзор",
      value1Bold: "для накоплений и правильного финансового управления",
      value2: "Бесплатный пробный месяц без обязательств",
      value3: "Скидка 50% на два дополнительных месяца",
      linkText: "Перейти на сайт RISE UP",
      bottomDisclaimer: "Нажатие на ссылку перенаправит вас на сайт Rise Up. Мы сотрудничаем с сайтом, направляя потенциальных клиентов в рамках коммерческого соглашения, включая комиссионные выплаты. Уточняем, что ни мы, ни сайт не взимаем с вас комиссию за это партнёрство.",
    },
    openFinanceModal: {
      header: "Как работает подключение?",
      topTextBold: "",
      topText: "С помощью открытого банкинга вы можете безопасно и быстро подключиться к своим счетам. Каждое подключение банковского/кредитного счёта является отдельным. После подключения мы добавим существующие продукты и будем регулярно обновлять ваши данные.",
      value1: "Передача данных осуществляется с наивысшим стандартом безопасности.",
      value2: "Политика «только чтение» — Monitor только считывает ваши данные, никакие действия с вашим счётом невозможны.",
      value3: "Процесс осуществляется с помощью Open Finance, которая помогает нам подключить ваши банковские счета в соответствии с нормативными требованиями Управления по ценным бумагам.",
      linkText: "Продолжить",
    },
    quilttModal: {
      header: "Подключение американского банка",
      topTextBold: "",
      topText:
        "Вы можете подключить свои банковские счета в США и видеть их рядом с остальными активами. После подключения мы добавим счета и будем регулярно обновлять остатки.",
      value1:
        "Подключение осуществляется через Quiltt и Finicity (компания группы Mastercard) с наивысшим стандартом безопасности.",
      value2:
        "Политика «только чтение» — Monitor только считывает ваши данные, никакие действия с вашим счётом невозможны.",
      value3:
        "Данные для входа в банк вводятся только напрямую в Finicity и не сохраняются в Monitor.",
      linkText: "Продолжить",
    },
    horizonModal: {
      topText: "Вы можете инвестировать в Bitcoin и Ethereum даже через регулярный платёж.",
      topTextBold: "Когда вы покупаете систематически каждый месяц (регулярный платёж), вы покупаете и когда рынок падает, и когда растёт, не позволяя эмоциям влиять на вас.",
      values: "Преимущества регулярного платежа через Horizon",
      value1: "Низкие минимальные суммы вклада от ₪150",
      value2: "Не хотите продолжать? Отмените в любое время",
      value3: "Horizon имеет расширенную лицензию на финансовые услуги под надзором Управления рынков капитала.",
      linkText: "Перейти на сайт Horizon",
      bottomDisclaimer: "Нажатие на ссылку перенаправит вас на сайт Horizon. Мы сотрудничаем с сайтом, направляя потенциальных клиентов в рамках коммерческого соглашения, включая комиссионные выплаты.",
    },
    lendaiModal: {
      topText: "Мы организовали партнёрство с Lendai, которая финансирует недвижимость в США для иностранных инвесторов, включая израильтян",
      topTextBold: "Не обязательно быть гражданином, чтобы покупать и инвестировать в недвижимость в США.",
      values: "В последние годы израильские инвесторы проявляют растущий интерес к инвестициям в недвижимость в США по нескольким причинам:",
      value1: "Возможность найти сделки с недвижимостью с более низким собственным капиталом, чем требуется на внутреннем рынке",
      value2: "Потенциал более высокой доходности",
      value3: "Рынок недвижимости в США очень дружелюбен к инвесторам",
      linkText: "Перейти на сайт LENDAI",
      bottomDisclaimer1: "Бесплатная первичная проверка, требуется заполнить данные. В категории LOAN TYPE выберите PRE APPROVAL.",
      bottomDisclaimer2: "Нажатие на ссылку перенаправит вас на сайт Lendai. Мы сотрудничаем с сайтом, направляя потенциальных клиентов в рамках коммерческого соглашения, включая комиссионные выплаты."
    },
    filter: {
      bankNotFound: "Не могу найти свой банк",
      bank2NotFound: "Не могу найти подходящий вариант",
      pensionNotFound: "Не могу найти свою инвестиционную компанию",
      shareNotFound: "Не могу найти своего брокера",
      cryptoNotFound: "Не могу найти свой кошелёк",
      debtNotFound: "Не могу найти подходящий вариант",
    },
    bottomRow: {
      preferManual: "Предпочитаю добавить вручную",
    },
    save: "Сохранить",
    notEditable: "Эти поля нельзя редактировать, так как они рассчитываются внешним провайдером.",
    openfinanceSuccessText:{
      header: "Подключение выполнено успешно!",
      details: "Вы можете увидеть добавленные продукты в таблице активов и обязательств",
      button: "Понятно, спасибо!"
    },
    openfinancePartialSuccessText:{
      header: "Подключение выполнено успешно!",
      details: "Некоторые продукты могут появиться в течение нескольких часов. Вы можете увидеть добавленные продукты в таблице активов и обязательств",
      button: "Понятно, спасибо!"
    },
    openfinanceFailText:{
      header: "Ошибка подключения",
      details: "Извините, во время процесса подключения произошла ошибка. Вы можете попробовать снова",
      button: "Попробовать снова"
    },
    openfinanceIncompleteText:{
      header: "Подключение всё ещё активируется",
      details: "Банк может завершить подключение в фоновом режиме. Если через 30 секунд оно всё ещё отображается как неактивное, немного подождите и обновите страницу. При загрузке страницы мы автоматически проверим статус ещё раз.",
      button: "Понятно"
    },
    openfinanceDeletedText:{
      header: "Подключение к банку удалено по вашему запросу",
      details: "Все продукты из этого подключения были удалены. Чтобы восстановить подключение и снова добавить продукты, нажмите «Переподключиться»",
      button: "Переподключиться"
    },
    openfinanceInitializingConnection: "Инициализация подключения к банку",
    openfinanceInitializingConnectionCard: "Инициализация подключения к кредитной карте",
    openfinanceFetchingProducts: "Импорт продуктов из банка, этот шаг может занять 30 секунд",
    openfinanceFetchingProductsCard: "Импорт продуктов из кредитной карты, этот шаг может занять 30 секунд",
  },
};
